import { GenerarReporteProductosPDF } from '../ReporteCatalogoProductos';
import { useEffect, useState } from "react";
import Card from "../../../../componentes/contenedores/Card";
import Page from "../../../../componentes/plantilla/Page";
import {
  ProductosCodigo,
  ProductosListar,
  ProductosNombre,
} from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import TablaBuscarProductos from "./TablaBuscarProductos";

const HomeBuscarProductos = () => {
  const { listaProductos,listaTiposProductos, setListaProductos, ActualizarLista } = useContextEmpleado();
  const { token } = useContextUsuario();
  const [busqueda, setBusqueda] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState("nombre");
  const [errorBusqueda, setErrorBusqueda] = useState(false);
  const [panelAbierto, setPanelAbierto] = useState(false);
  const [categoriaFiltro, setCategoriaFiltro] = useState("");
  const [productosFiltrados, setProductosFiltrados] = useState([]);

  const datos = {
    titulo: {
      titulo: "Busqueda productos",
      url: "/app/admin/productos/buscar",
      tituloUrl: "productos",
      nombreUrl: "buscar",
    },
  };

  useEffect(() => {
    ActualizarLista(ProductosListar, setListaProductos);
  }, []);

  useEffect(() => {
    const handleBuscar = () => {
      if (!busqueda) {
        // Si el campo de búsqueda está vacío, cargar la lista completa de productos
        ActualizarLista(ProductosListar, setListaProductos);
      } else if (busqueda.length >= 3) {
        setErrorBusqueda(false);
        if (tipoBusqueda === "codigo") {
          ActualizarLista(ProductosCodigo + busqueda, setListaProductos);
        } else if (tipoBusqueda === "nombre") {
          ActualizarLista(ProductosNombre + busqueda, setListaProductos);
        }
      }
    };

    handleBuscar();
  }, [busqueda, tipoBusqueda]);

  useEffect(() => {
    let listaFiltrada = listaProductos;

    if (categoriaFiltro && categoriaFiltro !== "") {
      const categoriaIdNumerica = parseInt(categoriaFiltro);

      listaFiltrada = listaFiltrada.filter(producto => {
        return producto.productoTipoId === categoriaIdNumerica;
      });
    }

    setProductosFiltrados(listaFiltrada);

  }, [listaProductos, categoriaFiltro]);

  const handleFiltrar = () => {
    setPanelAbierto(false);
  };

  const handleReset = () => {
    setCategoriaFiltro("");
    setPanelAbierto(false);
  };

  const renderFilterPanel = () => (
    <div className="mb-4 d-flex justify-content-end">
      <div className="position-relative">
        <button
          className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
          onClick={() => setPanelAbierto(!panelAbierto)}
          style={{
            borderRadius: "6px",
            padding: "6px 12px",
            fontSize: "0.9rem",
            minWidth: "140px",
          }}
        >
          <span className="d-flex align-items-center">
            <i className="fas fa-filter mx-2"></i>
            Filtros
          </span>
          <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
        </button>

        {panelAbierto && (
          <div
            className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
            style={{
              minWidth: "280px",
              right: 0,
              borderRadius: "10px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              padding: "15px",
              zIndex: 1050,
            }}
          >
            <div className="form-group mb-3">
              <label htmlFor="filtroCategoriaSelect" className="form-label fw-bold">Categoría</label>
              <select
                id="filtroCategoriaSelect"
                className="form-control form-control-sm"
                value={categoriaFiltro}
                onChange={(e) => setCategoriaFiltro(e.target.value)}
              >
                <option value="">Todas las categorías</option>
                {listaTiposProductos?.map((tipo) => (
                  <option key={tipo.id} value={String(tipo.id)}>
                    {tipo.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-flex">
              <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                <i className="fas fa-filter mx-1"></i> Filtrar
              </button>
              <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                <i className="fas fa-sync-alt mx-1"></i> Reset
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Page datos={datos}>
      <Card titulo="Buscar productos">
        {renderFilterPanel()}
        <TablaBuscarProductos datos={productosFiltrados}></TablaBuscarProductos>
      </Card>
    </Page>
  );
};

export default HomeBuscarProductos;